// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Editor_header__0qhu9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 15px;
}

.Editor_title__4UGWH {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.Editor_label__Mbnok {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.Editor_input__9ULE8,
.Editor_input__9ULE8 .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.Editor_itemColumn__nLlmD {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.Editor_itemSubmit__BJSRZ {
  margin-bottom: 0;
  text-align: right;
  margin-top: 20px;
}

.Editor_submit__6QFJB {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.Editor_swtichWrap__fyzP\\+ {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.Editor_swtichWrap__fyzP\\+ .Editor_label__Mbnok {
  margin-right: 10px;
}

.Editor_noMargin__0JEcn {
  margin-bottom: 0;
}

.Editor_uploadImage__gEkpu {
  border: 1px solid #d2d2d2;
  background-color: #fbfbfb;
  color: #383838;
  font-weight: 500;
  width: 100%;
  height: 35px;
  border-radius: 4px;
}

.Editor_center__G2j5T {
  text-align: center;
  display: block;
}

.Editor_preview__ZD-V4 {
  background-color: #f3f3f3;
  height: 120px;
  width: 120px;
  border-radius: 100%;
  margin: 0 auto 20px auto;
  background-size: cover;
  background-position: center;
}

.Editor_password__Hsj7g {
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/styles/Editor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EAExB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #cfcfcf;\n  padding-bottom: 15px;\n}\n\n.title {\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.label {\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 12px;\n}\n\n.input,\n.input :global(.ant-select-selector) {\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important;\n  border-radius: 4px !important;\n}\n\n.itemColumn {\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.itemSubmit {\n  margin-bottom: 0;\n  text-align: right;\n  margin-top: 20px;\n}\n\n.submit {\n  width: 250px;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.swtichWrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.swtichWrap .label {\n  margin-right: 10px;\n}\n\n.noMargin {\n  margin-bottom: 0;\n}\n\n.uploadImage {\n  border: 1px solid #d2d2d2;\n  background-color: #fbfbfb;\n  color: #383838;\n  font-weight: 500;\n  width: 100%;\n  height: 35px;\n  border-radius: 4px;\n}\n\n.center {\n  text-align: center;\n  display: block;\n}\n\n.preview {\n  background-color: #f3f3f3;\n  height: 120px;\n  width: 120px;\n  border-radius: 100%;\n  margin: 0 auto 20px auto;\n\n  background-size: cover;\n  background-position: center;\n}\n\n.password {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Editor_header__0qhu9`,
	"title": `Editor_title__4UGWH`,
	"label": `Editor_label__Mbnok`,
	"input": `Editor_input__9ULE8`,
	"itemColumn": `Editor_itemColumn__nLlmD`,
	"itemSubmit": `Editor_itemSubmit__BJSRZ`,
	"submit": `Editor_submit__6QFJB`,
	"swtichWrap": `Editor_swtichWrap__fyzP+`,
	"noMargin": `Editor_noMargin__0JEcn`,
	"uploadImage": `Editor_uploadImage__gEkpu`,
	"center": `Editor_center__G2j5T`,
	"preview": `Editor_preview__ZD-V4`,
	"password": `Editor_password__Hsj7g`
};
export default ___CSS_LOADER_EXPORT___;
